const normalizeBaseUrl = (value) => String(value || '').trim().replace(/\/+$/, '');

const coerceApiPath = (pathValue) => {
  const path = String(pathValue || '').trim();
  if (!path || path === '/') return '/api';

  const lowerPath = path.toLowerCase();
  const apiIndex = lowerPath.indexOf('/api');
  if (apiIndex >= 0) {
    return path.slice(0, apiIndex + 4);
  }

  return `${path.replace(/\/+$/, '')}/api`;
};

export const getApiBaseUrl = () => {
  const rawBase = normalizeBaseUrl(process.env.REACT_APP_API_BASE_URL);

  if (!rawBase) {
    // Local CRA development relies on package.json proxy for /api requests.
    return '/api';
  }

  if (rawBase.startsWith('/')) {
    return coerceApiPath(rawBase);
  }

  try {
    const parsed = new URL(rawBase);
    return `${parsed.origin}${coerceApiPath(parsed.pathname)}`;
  } catch {
    return /\/api$/i.test(rawBase) ? rawBase : `${rawBase}/api`;
  }
};

export const apiUrl = (path) => {
  const normalizedPath = String(path || '').startsWith('/') ? path : `/${path}`;
  return `${getApiBaseUrl()}${normalizedPath}`;
};
